// Console FAQ. Distinct from the sales FAQ: that one answers "should we buy this", this one
// answers "how do I do this" for somebody already signed in and mid-task.
//
// Every answer is grounded in what the console actually does. Where something is not wired,
// the answer says so rather than describing the intended behaviour.
// Checked line by line against the console code on 2026-10-19 (AF-1669).
window.CONSOLE_FAQ = {
  lead: 'The questions that come up while you are working, rather than what each page is.',

  groups: [
    {
      g: 'Reading the numbers',
      questions: [
        {
          q: 'Why does a number say est.?',
          a: 'It is modeled or estimated: calculated by us from real inputs, not measured. An est. number can be a good number and still not be a measured one. Developer and Super Admin see the full label instead: MEASURED, MODELED, ESTIMATED or SAMPLE.',
          roles: ['Everyone'],
        },
        {
          q: 'Which numbers can I repeat to a family or a surveyor?',
          a: 'Not the ones marked est. Anything marked est. is our calculation from real inputs, so it is useful for a decision and wrong to quote as a result.',
          roles: ['Everyone'],
        },
        {
          q: 'Performance says 85 and CMS says three stars. Which is right?',
          a: 'Both. They are different constructions. CMS starts from your health-inspection star, adds one for a five-star staffing rating and one for a five-star quality rating, subtracts one for a one-star rating in either, and never raises a one-star inspection by more than one. Ours is a weighted composite. They will not track each other.',
          roles: ['Operator', 'Facility Admin'],
        },
        {
          q: 'Why does one domain say ranked within state and the others do not?',
          a: 'Because CMS ranks health inspection within state, and we do not pretend otherwise. The other three domains use the peer tier you selected. A single national comparison across all four would be a false claim.',
          roles: ['Operator', 'Facility Admin'],
        },
      ],
    },
    {
      g: 'Alerts and who gets them',
      questions: [
        {
          q: 'Who gets an alert at 2am?',
          a: 'Whoever the alert ladder names, which your administrator sets in Settings, under Alert ladder. CRITICAL and HIGH page the resident’s caregiver, aide and charge nurse on shift and the Facility Admin, then everyone on shift if nobody acknowledges. MEDIUM goes to the aide on the wing, then the charge nurse, and waits during quiet hours. Nothing routes itself.',
          roles: ['Everyone'],
        },
        {
          q: 'What happens if I say I’m going and then get pulled away?',
          a: 'Saying I’m going does not close it. Paging keeps running for everyone until someone is with them. If nobody completes it, it stays on the list and its clock keeps running, which is the number a surveyor would ask about.',
          roles: ['Care Staff', 'Facility Admin'],
        },
        {
          q: 'Can I make it send me less?',
          a: 'Yes, in Settings under Notifications, per event type and severity. Critical alerts your building requires stay on and always go to two channels. Worth knowing why the default is narrow: alerts genuinely cut response times, and too many of them produce alarm fatigue that makes response worse than no alerts at all. Widen it once your team trusts what arrives.',
          roles: ['Operator', 'Facility Admin', 'Care Staff', 'Sales', 'Dev'],
        },
        {
          q: 'Why did a device reading not raise anything?',
          a: 'Check its grade in Settings under Integrations, on the Wearables tab. Anything below 40 is context only and cannot raise a signal on its own, however alarming the number looks. Blood pressure from a watch is a trend estimate and never alerts: only the cuffs do.',
          roles: ['Operator', 'Facility Admin'],
        },
      ],
    },
    {
      g: 'What I can and cannot see',
      questions: [
        {
          q: 'Why can I not see Family Portal?',
          a: 'It is the view a resident’s relatives log into, not a page you administer. What families can see is set on the resident, under Family access, not on that page.',
          roles: ['Facility Admin'],
        },
        {
          q: 'Why is the acquisition catalog missing for me?',
          a: 'It is operator-only and fails closed. A facility admin gets their own building and their own aggregate benchmark. That is a permission boundary rather than a display setting, so there is nothing to switch on.',
          roles: ['Facility Admin'],
        },
        {
          q: 'A resident’s family says they cannot see anything. Is it broken?',
          a: 'Probably not. Every kind of sharing starts switched off and stays off until it is turned on. Open the resident, check Family access, and change it with them rather than for them.',
          roles: ['Care Staff', 'Facility Admin'],
        },
      ],
    },
    {
      g: 'Empty pages and things that have not happened yet',
      questions: [
        {
          q: 'This page is empty. Is something wrong?',
          a: 'Usually the opposite. An empty Guardian queue means no safety signals right now, and Outcomes on the Sales page says No pilot running yet until a deal moves to Pilot in the CRM. We would rather show you an empty page than a plausible one.',
          roles: ['Everyone'],
        },
        {
          q: 'What happens if I skip the resident import?',
          a: 'Your setup checklist on Overview keeps reading no residents yet, and the resident pages stay empty until a roster exists. Your own survey and staffing comparison on Performance still works, because that comes from public CMS data we already hold.',
          roles: ['Facility Admin'],
        },
        {
          q: 'Why does a metric say not in v1?',
          a: 'It is graded so you know where the number would come from, but we are not collecting it yet. It cannot raise a signal, and showing you a bare grade for something we do not ingest would advertise a capability we do not have.',
          roles: ['Operator', 'Facility Admin'],
        },
      ],
    },
    {
      g: 'Money and reimbursement',
      questions: [
        {
          q: 'What is the difference between care delivered and billed?',
          a: 'Care delivered is the documented, billable care this month that has no claim on file yet. Practitioner billed is what was actually billed. Not billed is that care, less any billing that could not be matched to a resident, and it is the number Capture exists to show you.',
          roles: ['Operator', 'Facility Admin'],
        },
        {
          q: 'We pay per resident but are reimbursed per eligible resident. Do those match?',
          a: 'No, and the difference matters. Our fee is $99 per resident (occupied bed) per month, 90 days free for founding facilities, 30 days after that. Reimbursement is per eligible resident, which is a smaller number. The more of your census qualifies, the further ahead you are. In our Austin pilots, billing alone covered it: $87 to $99 per resident per month.',
          roles: ['Operator', 'Facility Admin'],
        },
        {
          q: 'Does Aithora submit the claim?',
          a: 'No. Reimbursement is billed by an enrolled practitioner, not by us. We surface what is capturable and document it; the billing stays with your provider.',
          roles: ['Operator', 'Facility Admin'],
        },
      ],
    },
    {
      g: 'When something is down',
      questions: [
        {
          q: 'How do I know if the problem is us or you?',
          a: 'Pulse shows every service check, and Connectors & probes shows every connector. If a facility reads degraded there, it is ours. If the connector to your EHR is the red one, its line says why: nothing received for over 24 hours, or messages rejected for a bad signature.',
          roles: ['Operator', 'Dev'],
        },
        {
          q: 'An incident is open. Who is on it?',
          a: 'Open it in Pulse, under Incidents. It names who was paged and whether anyone has acknowledged. Acknowledging halts escalation, so do it even if you have not fixed anything yet.',
          roles: ['Operator', 'Dev'],
        },
      ],
    },
    {
      g: 'Atlas and approvals',
      questions: [
        {
          q: 'Does approving a proposal execute it?',
          a: 'No. Approving re-runs the gate, and the gate can still refuse. If it runs, it leaves the queue. If the gate refuses it, or it needs another signature, it stays in the queue with the reason. An email waits 60 seconds with Undo before it goes.',
          roles: ['Operator', 'Facility Admin'],
        },
        {
          q: 'Can Atlas change a care plan or a medication?',
          a: 'No, not on its own, at any autonomy level. Clinical, emergency and Atlas directive actions always need a person: Atlas proposes, and a named human approves it or does it in the EHR or eMAR. No level can set them to run on their own.',
          roles: ['Everyone'],
        },
        {
          q: 'An Atlas answer looks short. Did it fail?',
          a: 'It may have withheld part of it. The gate reads the answer before it reaches you, and anything it stops is held back and the answer is marked WITHHELD.',
          roles: ['Operator', 'Facility Admin', 'Care Staff', 'Sales', 'Dev'],
        },
      ],
    },
  ],

  closing: 'Not here? Press Command-K (Ctrl-K on Windows) and type the page name or the term. If that does not answer it, the question is worth sending to us: a question we cannot answer from the console is usually a design problem rather than a training one.',
};
